import React from 'react';
import styled from '@emotion/styled';

const InvalidLinkContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  width: 100vw;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  background-color: #f8f8f8;
  font-family: Arial, sans-serif;
`;

const PhoneImageBackground = styled.div`
  position: relative;
  width: 100%;
  max-width: 500px;
  height: 100vh;
  background-size: cover;
  background-position: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
`;

const PhoneOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.85);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
`;

const LogoContainer = styled.div`
  margin-top: 280px;
  margin-bottom: 30px;
`;

const Logo = styled.img`
  width: 100px;
  opacity: 0.7;
`;

const ErrorContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  max-width: 340px;
  margin: 0 auto;
`;

const ResponseTitle = styled.h1`
  font-size: 24px;
  font-weight: 600;
  color: #333;
  margin-bottom: 20px;
`;

const ResponseDescription = styled.p`
  font-size: 16px;
  line-height: 1.5;
  color: #555;
  margin-bottom: 30px;
`;

const ContactInfo = styled.p`
  font-size: 18px;
  color: #000;
  text-shadow: 1px 1px 2px rgba(255, 255, 255, 0.8);

  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

const ContactLink = styled.a`
  color: #0078d4;
  text-decoration: none;
  font-weight: 600;

  &:hover {
    text-decoration: underline;
  }
`;

const RetryButton = styled.button`
  background-color: #9cc31c;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 12px 24px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  margin-bottom: 20px;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #88ad14;
  }
`;

const COPY_BY_VARIANT = {
  respondentDetails: {
    title: "We couldn't load your details",
    description:
      'Something went wrong while fetching your information. Please try again in a moment.'
  },
  screener: {
    title: 'Unable to load questions',
    description:
      "We're having trouble loading the questionnaire right now. Please refresh the page and try again."
  },
  design: {
    title: 'Something went wrong',
    description: "We couldn't load all the required questions. Please try again to continue."
  },
  preProfile: {
    title: 'Something went wrong',
    description: "We couldn't load all the required questions. Please try again to continue."
  }
};

const FetchErrorScreen = ({
  backgroundImageUrl = '',
  logoSrc = 'logo.png',
  variant = 'respondentDetails',
  onRetry = () => window.location.reload()
}) => {
  const copy = COPY_BY_VARIANT[variant] || COPY_BY_VARIANT.respondentDetails;

  return (
    <InvalidLinkContainer>
      <PhoneImageBackground style={{ backgroundImage: backgroundImageUrl ? `url(${backgroundImageUrl})` : undefined }}>
        <PhoneOverlay>
          <LogoContainer>
            <Logo src={logoSrc} alt="Exploratory Logo" />
          </LogoContainer>

          <ErrorContent>
            <ResponseTitle>{copy.title}</ResponseTitle>
            <ResponseDescription>{copy.description}</ResponseDescription>
            <RetryButton type="button" onClick={onRetry}>
              Retry
            </RetryButton>
            <ContactInfo>
              For Help: <ContactLink href="mailto:contact@explorastory.in">contact@explorastory.in</ContactLink>
            </ContactInfo>
          </ErrorContent>
        </PhoneOverlay>
      </PhoneImageBackground>
    </InvalidLinkContainer>
  );
};

export default FetchErrorScreen;
